import {ThreeColumnHero, ThreeColumnHeroDefinition} from './threeColumn/threeColumn'
import {TwoColumnHero, TwoColumnHeroDefinition} from './twoColumn/twoColumn'
import {SingleColumnHero, SingleColumnHeroDefinition} from './singleColumn/singleColumn'

export {
    ThreeColumnHero,
    ThreeColumnHeroDefinition,
    TwoColumnHero,
    TwoColumnHeroDefinition,
    SingleColumnHero,
    SingleColumnHeroDefinition
}
